import {
  JwtTokenActionTypes,
  LOGIN_FAIL,
  LOGIN_LOADING,
  LOGIN_SUCCESS,
  LoginState,
  LOGIN_UPDATE_API_MSG,
  LOGIN_UPDATE_API_RES,
} from "./ActionTypes";
import { LoginRes } from "./Model";

const initialStateGetPosts: LoginState = {
  loading: false,
  loginRes: {} as LoginRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const jwtAuthTokenReducer = (
  state = initialStateGetPosts,
  action: JwtTokenActionTypes,
): LoginState => {
  switch (action.type) {
    case LOGIN_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loginRes: action.payload,
        successMsg: action.successMsg,
      };
    case LOGIN_FAIL:
      return {
        ...state,
        loginRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case LOGIN_UPDATE_API_MSG:
      return {
        ...state,
        loginRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case LOGIN_UPDATE_API_RES:
      return {
        ...state,
        loginRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
